export enum DefaultParamsActionTypes {
  ApplyDefaultParams = '[DefaultParams] Apply Default Params',
  ResetDefaultParams = '[DefaultParams] Reset Default Params',
}
